import { Badge } from "@/components/ui/badge";
import { LinkToBackoffice } from "@/components/common/link-to-backoffice";

export function RoadmapStepHeader({
  title,
  position,
  stepId,
}: {
  title: string;
  position: number;
  stepId: number;
}) {
  return (
    <div className="mt-16">
      <Badge className="bg-remedium-blue mb-4 rounded-full px-2 py-0.5 text-white print:hidden">
        Krok {position + 1}
      </Badge>
      <h1 className="mb-4 text-2xl font-semibold">{title}</h1>
      {stepId && (
        <LinkToBackoffice type="roadmap_step" params={{ id: stepId }} />
      )}
    </div>
  );
}
